import React, { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import StorefrontRoundedIcon from "@mui/icons-material/StorefrontRounded";
import { useNavigate } from "react-router-dom";
import { routeConfigs } from "../../../navigation/routeConfig";
import { BODY_FONT, cardSx, DISPLAY_FONT, INK, INK_SOFT, PRIMARY } from "../dashboardTokens";

export const DashboardSearchBar: React.FC = () => {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");

  const submitSearch = () => {
    const trimmed = query.trim();
    if (trimmed) {
      navigate(`${routeConfigs.buy.path}?q=${encodeURIComponent(trimmed)}`);
    } else {
      navigate(routeConfigs.buy.path);
    }
  };

  return (
    <Box
      sx={{
        ...cardSx,
        p: { xs: 2, md: 2.5 },
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        gap: 1.5,
        alignItems: { xs: "stretch", md: "center" },
      }}
    >
      <TextField
        fullWidth
        size="small"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") submitSearch();
        }}
        placeholder="Search medications, NDC, or supplier..."
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchRoundedIcon sx={{ color: INK_SOFT }} />
            </InputAdornment>
          ),
          sx: {
            fontFamily: BODY_FONT,
            bgcolor: "#F8FAFC",
            borderRadius: "8px",
            "& fieldset": { borderColor: "#E2E8F0" },
          },
        }}
      />
      <Box
        sx={{
          display: "flex",
          gap: 1,
          flexShrink: 0,
          flexDirection: { xs: "column", sm: "row" },
        }}
      >
        <Button
          variant="contained"
          startIcon={<AddRoundedIcon />}
          onClick={() => navigate(routeConfigs.newSellItem.path)}
          sx={{
            fontFamily: DISPLAY_FONT,
            fontWeight: 600,
            textTransform: "none",
            borderRadius: "8px",
            bgcolor: PRIMARY,
            px: 2,
            whiteSpace: "nowrap",
            boxShadow: "none",
            "&:hover": { bgcolor: "#1D46A8", boxShadow: "none" },
          }}
        >
          Create Listing / Sell Order
        </Button>
        <Button
          variant="outlined"
          startIcon={<StorefrontRoundedIcon />}
          onClick={() => navigate(routeConfigs.buy.path)}
          sx={{
            fontFamily: DISPLAY_FONT,
            fontWeight: 600,
            textTransform: "none",
            borderRadius: "8px",
            borderColor: "#E2E8F0",
            color: INK,
            px: 2,
            whiteSpace: "nowrap",
            "&:hover": { borderColor: PRIMARY, bgcolor: "rgba(37, 99, 235, 0.04)" },
          }}
        >
          Browse Marketplace
        </Button>
      </Box>
    </Box>
  );
};

export default DashboardSearchBar;
